export default "__VITE_ASSET__D8V1pXzf__"